import { useAccount, useDisconnect } from "wagmi";
import { useModalStore } from "../../store/modle";
import { Dropdown, MenuProps, Modal, message } from "antd";
import whiteRight from "@/assets/images/whiteRight.svg";
import walletIcon from "@/assets/images/walletIcon.svg";
import walletconnect from "@/assets/images/walletconnect.svg";
import copyIcon from "@/assets/images/copy.svg";
import close from "@/assets/images/close.svg";

import copy from "copy-to-clipboard";
import { useWeb3Context } from "../providers/Web3ContextProvider";
import { useEffect, useState } from "react";
import { useDataStore } from "@/store/dataStore";
import { useNavigate } from "react-router-dom";

import styles from "./index.module.scss";
import { CacheAddress } from "@/constants/const";

export default function ConnectButton(): JSX.Element {
  const navigate = useNavigate();

  const { address, connector } = useAccount();
  const { logout } = useWeb3Context();
  const { disconnect } = useDisconnect();
  const isMobile = useDataStore((state) => state.isMobile);
  const setShowProviderModal = useModalStore(
    (state) => state.setShowProviderModal
  );
  const baseItems: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div className={styles.menuItem}>
          <img
            src={
              connector?.name === "WalletConnect" ? walletconnect : walletIcon
            }
            width={20}
            alt="walletIcon"
          />
          <div className={styles.menuItemAddress}>{address}</div>
          <img
            src={copyIcon}
            width={13}
            alt=""
            onClick={() => {
              copyText();
            }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          className={styles.menuItemDis}
          onClick={() => {
            navigate("/", { replace: true });
            logout();
            disconnect();
            localStorage.setItem(CacheAddress.cacheAddress, "");
          }}
        >
          <div className={styles.menuItemDisconnect}>Disconnect Wallet</div>
        </div>
      ),
    },
  ];

  const [items, setItems] = useState(baseItems);
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    let list = baseItems;
    setItems(list);
  }, [address]);

  const copyText = () => {
    copy(address || "");
    message.success("copy success !");
  };

  const addr = address
    ? address?.slice(0, 6) +
      "• • •" +
      address?.slice(address.length - 4, address.length)
    : "• • •";

  const MobileDisconnectModal = () => {
    return (
      <Modal
        open={openMenu}
        title="Disconnect Wallet"
        onOk={() => setOpenMenu(false)}
        onCancel={() => setOpenMenu(false)}
        closeIcon={<img src={close} alt="logo" width={24} height={24} />}
        destroyOnHidden
        className={styles.walletModal}
        footer={null}
        width={410}
      >
        <div className={styles.walletShow}>
          <div className={styles.mobileMenuItem}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={walletIcon} width={20} alt="walletIcon" />
              <div className={styles.menuItemAddress}>{address}</div>
            </div>
            <img
              src={copyIcon}
              width={16}
              alt=""
              onClick={() => {
                copyText();
              }}
            />
          </div>
          <div
            className={styles.disconnectWallet}
            onClick={() => {
              logout();
              disconnect();
              localStorage.setItem(CacheAddress.cacheAddress, "");
              window.location.reload();

              // setRefreshData(!refreshData);
            }}
          >
            Disconnect
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <>
      {localStorage.getItem(CacheAddress.cacheAddress) ? (
        <Dropdown
          open={openMenu && !isMobile}
          menu={{ items }}
          className={styles.walletDropdown}
          placement={"bottomRight"}
          onOpenChange={(open) => {
            setOpenMenu(open);
          }}
          overlayClassName={styles.dropDownList}
        >
          <div className={styles.menuWordBox}>
            <div
              onClick={(e) => e.preventDefault()}
              className={styles.menuWord}
            >
              {!isMobile && (
                <img
                  src={
                    connector?.name === "WalletConnect"
                      ? walletconnect
                      : walletIcon
                  }
                  width={20}
                  height={20}
                  alt=""
                  style={{ marginRight: 6 }}
                />
              )}
              <div className={styles.linkedAddress}>{addr}</div>
            </div>
          </div>
        </Dropdown>
      ) : (
        <div
          className={styles.connectBtn}
          onClick={() => setShowProviderModal(true)}
        >
          Connect Wallect
          {!isMobile && <img src={whiteRight} alt="whiteRight" width={20} />}
        </div>
      )}
      {openMenu && isMobile && <MobileDisconnectModal />}
    </>
  );
}
